import TramiteForm from "../TramiteForm/TramiteForm";

const TramiteFormModal = ({ form, application, onClose, edit }) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-[1200] flex items-center justify-center">
      <div className="bg-white rounded-2xl w-full max-w-4xl p-6 shadow-lg max-h-[650px] overflow-y-auto">

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ✕
          </button>
        </div>

        <TramiteForm
          form={form}
          application={application}
          onClose={onClose}
          edit={edit}
        />
      </div>
    </div>
  );
};

export default TramiteFormModal;
